import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-semibold rounded-full mb-3">
            品牌故事
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            {aboutData.title}
          </h2>
          <div className="mt-6 md:mt-8 space-y-4">
            {aboutData.paragraphs.map((p, i) => (
              <p
                key={i}
                className="text-sm md:text-base text-foreground-500 leading-relaxed"
              >
                {p}
              </p>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-movie-2-line text-primary-500 text-lg"></i>
              <span className="font-semibold text-foreground-700">12+</span>
              内容品类
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-user-line text-primary-500 text-lg"></i>
              <span className="font-semibold text-foreground-700">800万+</span>
              日活用户
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-play-circle-line text-primary-500 text-lg"></i>
              <span className="font-semibold text-foreground-700">30亿+</span>
              月播放量
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-upload-cloud-2-line text-primary-500 text-lg"></i>
              <span className="font-semibold text-foreground-700">200+</span>
              每日上新
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}